import script from "./MainTitle.vue?vue&type=script&setup=true&lang=js"
export * from "./MainTitle.vue?vue&type=script&setup=true&lang=js"

import "./MainTitle.vue?vue&type=style&index=0&id=306d1746&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-306d1746"]])

export default __exports__